import portalUsersSaga from './sagas'
import slice from './reducer'

export const {
  fetchRequest: portalUserRequest,
  fetchSuccess: portalUserSuccess,
  fetchError: portalUserError,
  updateFilters: portalUserFilters,
} = slice.actions

export default slice.reducer
export { portalUsersSaga }
